var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank59(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    style: {
      width: "1.0712890625em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1097 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M548.571429 0l548.571428 219.428571v73.142858h-73.142857c0 20.004571-17.700571 36.571429-39.424 36.571428H112.566857C90.843429 329.142857 73.142857 312.576 73.142857 292.571429H0V219.428571zM146.285714 365.714286h146.285715v438.857143h73.142857V365.714286h146.285714v438.857143h73.142857V365.714286h146.285714v438.857143h73.142858V365.714286h146.285714v438.857143h33.718857c21.723429 0 39.424 16.566857 39.424 36.571428v36.571429H73.142857v-36.571429c0-20.004571 17.700571-36.571429 39.424-36.571428H146.285714V365.714286z m911.433143 548.571428c21.723429 0 39.424 16.566857 39.424 36.571429v73.142857H0v-73.142857c0-20.004571 17.700571-36.571429 39.424-36.571429h1018.294857z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank59);
export default __webpack_public_path__ + "static/media/bank-59.6c06e6c6b96529e398f298aa974cf4b8.svg";
export { ForwardRef as ReactComponent };